<template>
  <div>
    <el-option
      class="box"
      v-for="v in value"
      :key="`${uniKey}${v[idKey]}`"
      :label="v[nameKey]"
      :value="v[idKey]"
      :disabled="disabledId.includes(v[idKey])"
    >
      <div class="main">
        <v-avatar v-model="v[avatarKey]" :size="size" :ratio="ratio" :radius="radius"/>
        <div class="nickname-box">
          <template v-if="v[briefKey]">
            <div class="nickname">{{v[nameKey]}}</div>
            <div class="brief">{{v[briefKey]}}</div>
          </template>
          <div v-else class="nickname-single">{{v[nameKey]}}</div>
        </div>
      </div>
    </el-option>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    uniKey: {
      type: String,
      default: 'avatarOption',
    },
    disabledId: {
      type: Array,
      default: () => [],
    },
    idKey: {
      type: String,
      default: 'id',
    },
    avatarKey: {
      type: String,
      default: 'avatar',
    },
    nameKey: {
      type: String,
      default: 'nickname',
    },
    briefKey: {
      type: String,
      default: 'phone',
    },
    size: {
      type: Number,
      default: 50,
    },
    ratio: {
      type: Number,
      default: 1,
    },
    radius: {
      type: String,
      default: '50%',
    },
  },
};
</script>

<style scoped>
  .box {
    display: flex;
    align-items: center;
    height: 60px;
  }

  .main {
    display: flex;
    align-items: center;
    height: 60px;
  }

  .nickname-box {
    display: flex;
    flex-direction: column;
    height: 50px;
    margin-left: 15px;
  }

  .nickname {
    height: 25px;
    line-height: 25px;
  }

  .brief {
    color: #8492a6;
  }

  .nickname-single {
    height: 50px;
    line-height: 50px;
  }
</style>
